// extracted by mini-css-extract-plugin
export default {"modal":"modal--7fe5aea","openedModal":"openedModal--1fe5bdb","close":"close--d33fb94"};